import React from 'react'
import { Heading, Text, Button, Flex } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Flex direction="column" align="center" gap="4">
        <Heading size="8">404</Heading>
        <Text size="4" color="gray">Page Not Found</Text>
        <Button onClick={() => navigate('/login')}>Return to Login</Button>
      </Flex>
    </div>
  )
}
